import classNames from 'classnames'
import { motion } from 'motion/react'
import React, { FC, useEffect, useMemo, useState } from 'react'

import { useArabicSessionLanguage } from '@context/SessionSettingsContext'

import styles from './ToggleSwitch.module.scss'

export interface ToggleOption {
  id: string | number
  name: string
  onClick: () => void
  condition?: boolean
}

interface ToggleSwitchProps {
  tabs: ToggleOption[]
  initialTab?: string | number
  activeTab?: string | number
}

export const ToggleSwitch: FC<ToggleSwitchProps> = (props) => {
  const { tabs, activeTab: tabOverride } = props
  const parsedTabs = useMemo(() => tabs.filter((tab) => tab.condition !== false), [tabs])
  const isArabic = useArabicSessionLanguage()
  const { initialTab = parsedTabs[0].id } = props
  const [activeTab, setActiveTab] = useState(initialTab)
  const activeIndex = parsedTabs.findIndex((t) => t.id === (tabOverride ?? activeTab))

  useEffect(() => {
    setActiveTab(initialTab)
  }, [initialTab])

  const handleClick = (idx: number, onClick: () => void) => {
    setActiveTab(parsedTabs[idx].id)
    onClick()
  }

  return (
    <div className={styles.toggleContainer}>
      <motion.div
        className={styles.indicator}
        style={{
          width: `calc(${100 / parsedTabs.length}% - ${isArabic ? '0.25rem' : '0.125rem'})`,
        }}
        animate={
          isArabic
            ? {
                insetInlineStart: `${activeIndex * (100 / parsedTabs.length)}%`,
              }
            : { x: `${activeIndex * 100}%` }
        }
        transition={{ type: 'tween', duration: 0.3 }}
      />
      {parsedTabs.map((tab, idx) => (
        <button
          key={tab.id}
          className={classNames(styles.option, {
            [styles.active]: idx === activeIndex,
          })}
          onClick={() => handleClick(idx, tab.onClick)}
        >
          {tab.name}
        </button>
      ))}
    </div>
  )
}
